module.exports = __webpack_public_path__ + "img/link-icon-vase.3c63ec1e.svg";